import {
  addOnOrderListById,
  orderDetailsById,
  orderJobListById,
} from "../../redux/reducers/myOrdersSlice";
import catchAsync from "../../utils/catchAsync";
import http from "./http";

export const gettingMyOrdersListApi = catchAsync(async (values) => {
  const data = await http.post(`/order/get-orders`, values);

  return data;
});
// Pending Orders List API In Dashboard
export const gettingPendingOrdersListApi = catchAsync(async (values) => {
  const data = await http.post(`/order/get-pending-orders`, values);

  return data;
});
export const gettingMyOrdersDetailsApi = catchAsync(async (values) => {
  const data = await http.get(`/order/view/${values}`);

  return data;
});
export const gettingJobListByIdsApi = catchAsync(async (values) => {
  const data = await http.get(`/order/order-job-list/${values}`);

  return data;
});
export const gettingAddOnOrderListByIdsApi = catchAsync(async (values) => {
  const data = await http.get(`/order/add-on-order-list/${values}`);

  return data;
});

export const checkPriceApi = catchAsync(async (values) => {
  let userDetails = JSON.parse(JSON.parse(localStorage.getItem('persist:ohc'))?.auth)?.user
  let bodyData = values?.values
  if (userDetails) {
    bodyData.createdFor = userDetails._id
  }
  const data = await http.post(`/order/calculate-price`, bodyData);

  return data;
});

export const getStaffsApi = catchAsync(async (values) => {
  const data = await http.post(
    `/order/reschedule-check-staff-availability`,
    values?.values
  );

  return data;
});

export const getStaffsGenRegApi = catchAsync(async (values) => {
  const data = await http.post(
    `/order/regular-staff-availability`,
    values?.values
  );

  return data;
});

export const checkDiscountApi = catchAsync(async (values) => {
  const data = await http.post(`/order/discount-code-check`, values?.values);
  return data;
});
export const checkDiscountNonAuthApi = catchAsync(async (values) => {
  const data = await http.post(`/order/get-discount-check`, values?.values);
  return data;
});

export const createNewOrderApi = catchAsync(async (values) => {
  const data = await http.post(`/order/create`, values?.values);

  return data;
});

export const getAllServicedDataApi = catchAsync(async (values) => {
  const data = await http.get(`/service/service-list`);
  return data;
});

export const getS3SignUrl = catchAsync(async (values) => {
  const data = await http.post(`/order/get-presigned-url`, values);

  return data;
});
export const rescheduledJobsApi = catchAsync(async (values) => {
  const data = await http.post(`/jobs/reschedule-job`, values);

  return data;
});
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export async function pushProfilePhotoToS3(file) {
  const myHeaders = new Headers({
    "Content-Type": file?.type?.includes("image")
      ? "image/*"
      : file?.type?.includes("video")
        ? "video/*"
        : "",
  });
  let blob = dataURLtoFile(file.file, file.name);
  try {
    const response = await fetch(file?.link, {
      method: "PUT",
      headers: myHeaders,
      body: blob,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export const getPaymentDetailsOrder = catchAsync(async (values) => {
  const data = await http.get(`/order/order-payment-details/${values}`);

  return data;
});

export const updatePaymentRequest = async (values) => {
  let url = `${process.env.REACT_APP_API_URL.replace(
    "/customer",
    ""
  )}/webhooks/payment-success-ohc`;
  try {
    const response = await http.post(url, values.body);

    values.dispatch(orderDetailsById(values.id));
    values.dispatch(orderJobListById(values.id));
    values.dispatch(addOnOrderListById(values.id));
    values.getPaymentDetails();
    return response;
  } catch (error) {
    return error.response.data;
  }
};
